<template>
  <div>
    <h1>Unreplied messages</h1>
    <p>
      <v-btn v-if="$keycloak.hasRealmRole('root')" @click="storeLatest">
        <v-icon>refresh</v-icon>&#160;Store latest
      </v-btn>
      <v-btn
        v-if="$keycloak.hasRealmRole('root')"
        @click="updateMessagesWithEntityTypeId"
      >
        <v-icon>refresh</v-icon>&#160;Update messages with entityTypeId
      </v-btn>
    </p>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="count"
      :loading="$apollo.queries.messages.loading"
      :headers="headers"
      :items="modifiedMessages"
      class="elevation-1"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <FileGql :file="props.item.file" v-if="props.item.file" />
          </td>
          <td>{{ props.item.body }}</td>
          <td>
            {{ props.item.days }}
            <v-btn
              @click="deleteMessage(props.item)"
              small
              v-if="$keycloak.hasRealmRole('root')"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UNREPLIED_MESSAGES from "@/graphql/message/UnrepliedMessages";
import UNREPLIED_MESSAGES_COUNT from "@/graphql/message/UnrepliedMessagesCount";
import DELETE_MESSAGE from "@/graphql/message/DeleteMessage";
import STORE_MESSAGE_STATS from "@/graphql/message/StoreMessageStats";
import UPDATE_MESSAGES_WITH_ENTITYTYPEID from "@/graphql/message/UpdateMessagesWithEntityTypeId";
import { differenceInDays, parseISO } from "date-fns";
import FileGql from "@/components/link/FileGql";
export default {
  name: "Unreplied",
  metaInfo() {
    return {
      title: "Unreplied messages",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    messages: {
      query: UNREPLIED_MESSAGES,
      variables() {
        return {
          first: this.firstRow,
          pagesize: this.pagination.rowsPerPage,
          sortby: this.pagination.sortBy,
          descending: this.pagination.descending
        };
      },
      update: (data) => data.unrepliedMessages,
      fetchPolicy: "cache-and-network"
    },
    count: {
      query: UNREPLIED_MESSAGES_COUNT,
      update: (data) => data.unrepliedMessagesCount,
      fetchPolicy: "cache-and-network"
    }
  },
  components: { FileGql },
  computed: {
    firstRow() {
      const { page, rowsPerPage } = this.pagination;
      return (page - 1) * rowsPerPage;
    },
    modifiedMessages() {
      if (!this.messages) {
        return undefined;
      }
      const now = new Date();
      return this.messages.map((m) => {
        const end = parseISO(m.timestamp);
        const days = differenceInDays(now, end);
        return { ...m, days };
      });
    }
  },
  data() {
    return {
      files: null,
      headers: [
        {
          text: "Reference",
          value: "file.referencelong"
        },
        {
          text: "Body",
          value: "body"
        },
        {
          text: "Age (days)",
          value: "timestamp"
        }
      ],
      filters: {
        id: null,
        fileid: null,
        body: null,
        timestamp: null
      },
      pagination: {
        page: 1,
        rowsPerPage: 25,
        sortBy: "timestamp",
        descending: false
      },
      showFirstLastPage: true,
      showCurrentPage: true
    };
  },
  methods: {
    async storeLatest() {
      await this.$apollo.mutate({ mutation: STORE_MESSAGE_STATS });
    },
    async updateMessagesWithEntityTypeId() {
      const response = await this.$apollo.mutate({
        mutation: UPDATE_MESSAGES_WITH_ENTITYTYPEID
      });
      alert(response.data.updateMessagesWithEntityTypeId);
    },
    async deleteMessage(item) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_MESSAGE,
          variables: { id: item.id },
          refetchQueries: [
            { query: UNREPLIED_MESSAGES },
            { query: UNREPLIED_MESSAGES_COUNT }
          ]
        });
      }
    }
  }
};
</script>